//src/env.js

export function getEnvVar(key) {
    return window?.__ENV__?.[key] || import.meta.env[key];
}